import React from "react";
import { BadgeCheck } from "lucide-react";

/**
 * Gold verified tick for Plyx creators. Drop next to a handle anywhere:
 *   <span>{handle} <VerifiedBadge user={creator} /></span>
 *
 * Renders nothing if the creator isn't verified — safe to scatter freely.
 */
const VerifiedBadge = ({ user, size = 14, className = "" }) => {
  if (!user?.is_verified) return null;
  return (
    <BadgeCheck
      data-testid="plyx-verified-badge"
      className={`inline-block align-middle text-[#FFB42D] drop-shadow ${className}`}
      style={{ width: size, height: size, fill: "currentColor", color: "#FFB42D", stroke: "#0A0A0A", strokeWidth: 1.5 }}
      aria-label="Verified creator"
      title="Verified creator"
    />
  );
};

export default VerifiedBadge;
